<template>
  <div class="bq-nav-wrapper">
    <div class="bq-toggle-menu" v-if="isMobile" @click="toggle"></div>

    <div class="bq-close" v-if="isMobile && isToggle" @click="toggle"></div>

    <ul class="bq-nav" :class="{ mobile: isMobile, toggle: isToggle }">
      <template v-for="(item, idx) in lists">
        <li
          class="bq-nav-item"
          :key="item.name"
          :class="{ active: active === item.path }"
          @click="jump(item, idx)"
          v-if="!isMobile"
        >
          <el-dropdown placement="bottom" v-if="item.path === '/solution'">
            <span class="bq-nav-txt">
              <span>{{ item.name }}</span>
              <i class="bq-nav-slider"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '1' }"
                  ><span @click="handleClick('solution', '1')"
                    >省卫健委合作项目</span
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '2' }"
                  ><span @click="handleClick('solution', '2')"
                    >智慧医院</span
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '3' }"
                  ><span @click="handleClick('solution', '3')"
                    >全民健康信息平台</span
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </span>
          </el-dropdown>

          <el-dropdown placement="bottom" v-else-if="item.path === '/product'">
            <span class="bq-nav-txt">
              <span>{{ item.name }}</span>
              <i class="bq-nav-slider"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '1' }"
                  ><span @click="handleClick('product', '1')"
                    >健康医疗数据中心</span
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '2' }"
                  ><span @click="handleClick('product', '2')"
                    >智慧服务</span
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '3' }"
                  ><span @click="handleClick('product', '3')"
                    >智慧临床</span
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '4' }"
                  ><span @click="handleClick('product', '4')">
                    智慧管理</span
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </span>
          </el-dropdown>

          <el-dropdown placement="bottom" v-else-if="item.path === '/about'">
            <span class="bq-nav-txt">
              <span>{{ item.name }}</span>
              <i class="bq-nav-slider"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '0' }"
                  ><span @click="handleClick('about', '0')"
                    >公司简介</span
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '1' }"
                  ><span @click="handleClick('about', '1')"
                    >扁鹊孵化器</span
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '2' }"
                  ><span @click="handleClick('about', '2')"
                    >新闻动态</span
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </span>
          </el-dropdown>

          <el-dropdown placement="bottom" v-else-if="item.path === '/contact'">
            <span class="bq-nav-txt">
              <span>{{ item.name }}</span>
              <i class="bq-nav-slider"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '0' }"
                  ><span @click="handleClick('contact', '0')"
                    >合作咨询</span
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  :class="{ active: active === item.path && queryId === '1' }"
                  ><span @click="handleClick('contact', '1')"
                    >加入我们</span
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </span>
          </el-dropdown>

          <span class="bq-nav-txt" v-else>
            <span>{{ item.name }}</span>
            <i class="bq-nav-slider"></i>
          </span>
        </li>

        <li
          class="bq-nav-item"
          :key="item.name"
          @click="itemSelect(item)"
          v-if="isMobile"
        >
          <h2 class="bq-nav-title">{{ item.name }}</h2>
          <h3 class="bq-nav-subtitle">{{ item.subTitle }}</h3>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
// import { isWirelessDevice } from '../../../utils/utils';

export default {
  name: 'BQNav',

  props: {
    lists: Array,
  },

  data() {
    return {
      isMobile: false,
      isToggle: false,
      currentNav: '',
    };
  },

  created() {
    console.log(this.lists);
    // this.isMobile = isWirelessDevice();
  },

  computed: {
    active() {
      return this.$route.path;
    },
    queryId() {
      return this.$route.query && this.$route.query.id;
    },
  },

  methods: {
    handleClick(type, idx) {
      if (this.$route.fullPath === `/${type}?id=${idx}`) {
        return;
      }
      this.$router.push(`/${type}?id=${idx}`);
    },

    jump(item, idx) {
      if (
        item.path === this.$route.path ||
        item.path === '/solution' ||
        item.path === '/about' ||
        item.path === '/contact' ||
        item.path === '/product'
      ) {
        return;
      }
      this.$emit('active', idx);

      this.$router.push(item.path);
    },

    toggle() {
      this.isToggle = !this.isToggle;
    },

    itemSelect(nav) {
      if (nav.path === this.$route.path) {
        return;
      }

      this.isToggle = !this.isToggle;

      this.$router.push(nav.path);
    },
  },
};
</script>

<style lang="less">
@import './index.less';
.el-popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: #2b2e40 !important;
  &::after {
    // border-color: #2b2e40 !important;
    border-bottom-color: #2b2e40 !important;
  }
}
</style>
